import PromotedStrainCarousel from "./StrainCarousel";

export default PromotedStrainCarousel;
